import { drawRider } from './drawRider';
import type { VesselDrawState } from './types';

/**
 * PWC: a runabout jet ski with a dark hull and rivet strake, tan deck and red
 * front cowl. Bow right.
 *
 * The rider is the same figure as the kayak's, seated forward and leaning onto
 * the bars. The counterlean against the hull's pitch keeps them near upright as
 * the hull works.
 */
export const drawJetSki = ({
  palette,
  night,
  pitchRad,
}: VesselDrawState): void => {
  const { ctx } = palette;
  const c = (hex: string): string => palette.colour(hex);

  // hull base
  ctx.beginPath();
  ctx.moveTo(-40, -3);
  ctx.quadraticCurveTo(-44, -3, -44, 1);
  ctx.lineTo(-42, 5);
  ctx.quadraticCurveTo(-10, 9, 30, 7);
  ctx.quadraticCurveTo(46, 5, 50, -2);
  ctx.quadraticCurveTo(48, -4, 40, -4);
  ctx.quadraticCurveTo(0, -2, -40, -3);
  ctx.closePath();
  const hull = ctx.createLinearGradient(0, -4, 0, 8);
  hull.addColorStop(0, c('3A3F45'));
  hull.addColorStop(1, c('17191C'));
  ctx.fillStyle = hull;
  ctx.fill();

  ctx.fillStyle = c('6A7078');
  for (let x = -34; x < 34; x += 8) {
    ctx.beginPath();
    ctx.arc(x, 2, 0.8, 0, Math.PI * 2);
    ctx.fill();
  }

  // tan deck body
  ctx.beginPath();
  ctx.moveTo(-38, -4);
  ctx.quadraticCurveTo(-30, -12, -6, -13);
  ctx.quadraticCurveTo(20, -14, 36, -12);
  ctx.quadraticCurveTo(48, -10, 49, -3);
  ctx.quadraticCurveTo(30, -3, -6, -3);
  ctx.quadraticCurveTo(-30, -3, -38, -4);
  ctx.closePath();
  const deck = ctx.createLinearGradient(0, -14, 0, -3);
  deck.addColorStop(0, c('E8B488'));
  deck.addColorStop(1, c('C98A55'));
  ctx.fillStyle = deck;
  ctx.fill();
  ctx.strokeStyle = c('A06A3A');
  ctx.lineWidth = 0.6;
  ctx.stroke();

  // red front cowl
  ctx.beginPath();
  ctx.moveTo(20, -12);
  ctx.quadraticCurveTo(34, -15, 44, -11);
  ctx.quadraticCurveTo(50, -9, 49, -4);
  ctx.quadraticCurveTo(40, -7, 28, -7);
  ctx.quadraticCurveTo(22, -8, 20, -12);
  ctx.closePath();
  const cowl = ctx.createLinearGradient(0, -15, 0, -4);
  cowl.addColorStop(0, c('D14B3A'));
  cowl.addColorStop(1, c('9E2C20'));
  ctx.fillStyle = cowl;
  ctx.fill();

  // black seat hump
  ctx.beginPath();
  ctx.moveTo(-30, -9);
  ctx.quadraticCurveTo(-20, -17, -2, -17);
  ctx.quadraticCurveTo(8, -17, 12, -12);
  ctx.lineTo(12, -9);
  ctx.quadraticCurveTo(-10, -9, -30, -9);
  ctx.closePath();
  ctx.fillStyle = c('2A2E33');
  ctx.fill();

  // handlebar column + bar, pulled back over the seat so the reach is natural
  ctx.strokeStyle = c('202428');
  ctx.lineWidth = 2.2;
  ctx.beginPath();
  ctx.moveTo(16, -12);
  ctx.lineTo(18, -21);
  ctx.stroke();
  ctx.lineWidth = 2.6;
  ctx.beginPath();
  ctx.moveTo(13, -21);
  ctx.lineTo(21, -20);
  ctx.stroke();

  drawRider(palette, 1, -16, 0.28 + pitchRad * 0.35, [18, -21], [15, -20]);

  if (night > 0.04) {
    palette.navGlow(-40, -6, 7, '255,250,235', Math.min(0.95, night * 1.05));
  }
};
